import { useQuery } from '@tanstack/react-query';
import { apiFetch, ApiError } from './api.js';

export interface Me {
  id: string;
  username: string;
  displayName: string;
  email: string;
  role: 'admin' | 'operator' | 'viewer';
  totpEnabled: boolean;
  mfaPending: boolean;
}

export function useSession() {
  return useQuery<Me | null>({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      try {
        return await apiFetch<Me>('/auth/me');
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 30_000,
    retry: false,
  });
}
